/**
 * 4.3.2 walkthrough slides.
 *
 * Each slide:
 *   {
 *     image:          public-path string (e.g. '/walkthroughs/4.3.2/foo.png'),
 *     title:          short heading,
 *     body:           one or two sentences describing the change,
 *     minRoleWeight?: integer — only users with role_weight >= this see the slide
 *                     (matches hasMinRole gating; omit for "visible to everyone")
 *   }
 *
 * Drop walkthrough images under public/walkthroughs/{version}/.
 */
export default [
  {
    image: '/walkthroughs/4.3.2/training_badge_2.jpg',
    title: 'We have added badges',
    body: 'Badges can now be earned by completing unique milestones such as completing your onboarding training.',
    minRoleName: "Everyone",
    minRoleWeight: 0
  },{
    image: '/walkthroughs/4.3.2/slide_1.png',
    title: 'Run scheduled reports locally',
    body: 'You can now trigger to instantly run a scheduled report right in the portal with two clicks.',
    minRoleName: "All Administrators, Corporate",
    minRoleWeight: 10
  },{
    image: '/walkthroughs/4.3.2/slide_3.png',
    title: 'Wandering badge quick assignment',
    body: 'Portal now supports assigning wandering badges through our new one click device assignment workflow.',
    minRoleName: "All Administrators, Corporate",
    minRoleWeight: 10
  },{
    image: '/walkthroughs/4.3.2/slide_4.png',
    title: 'Reason code descriptions',
    body: 'Alert reasons can now have descriptions added to better facilitate correct reason selection.',
    minRoleName: "Super Administrators, Corporate",
    minRoleWeight: 20
  },
];
